import * as Sentry from "@sentry/react";

import { SentryLink, excludeGraphQLFetch } from 'apollo-link-sentry';

import { Integrations } from "@sentry/tracing";
import config from "config";
import { onError } from "@apollo/client/link/error";
import toast from "react-hot-toast";
import rollbar from "utils/rollbar";

Sentry.init({
  environment: config.sentry.env,
  dsn: config.sentry.dsn,
  integrations: [new Integrations.BrowserTracing({
    traceFetch: false
  })],
  beforeBreadcrumb: excludeGraphQLFetch,
  enabled: config.env === "development",

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const sentryMiddleware = new SentryLink({
  uri: config.apollo.uri,
  setTransaction: true,
  setFingerprint: true,
})

const errorMiddleware = onError((errors) => {
  if (errors.response) {
    rollbar.error(errors.response.errors);
    toast.error(errors?.response?.errors?.at(0)?.message || "An error occurred");
  }

  // errors.graphQLErrors.forEach(({ message, locations, path, extensions }) => {
  //   toast.error(message);
  // });

  if (errors.networkError) {
  }
  Sentry.captureException(errors)
}).split(
  () => config.env === "production",
  sentryMiddleware
)

export default errorMiddleware;